import {Box, Grid, Stack, Typography} from "@mui/material";
import React from "react";
import {saraTheme} from "../theme/saraTheme";
import {Title} from "./Register/FormContent";

const CustomParcheggio = ({parkingId}) => {
    const parcheggio = parkings[parkingId]
    return (parcheggio && <Stack>
            {/*<Box sx={{width: '100%', height: '0.07rem', background: saraTheme.palette.secondary.main}}/>*/}
            <Title title={`PARCHEGGIO ${parcheggio.title}`} />
            <Typography>
                {parcheggio.description}
            </Typography>
            <Box mt={4} sx={{width: '100%', height: '0.07rem', background: saraTheme.palette.secondary.main}}/>
        </Stack>
    );
}

export default CustomParcheggio

const parkings = {
    parcheggioRoma: {
        title: "A.Roma Lifestyle Hotel",
        description: <>
            In hotel è presente un parcheggio esterno e/o sotterraneo fino a 200 posti non prenotabili, gratuito.
        </>,
    },
    parcheggioMilano: {
        title: "Sheraton San Siro",
        description: <>
            In hotel è presente un parcheggio esterno e/o sotterraneo fino a 180 posti non prenotabili, a pagamento.
            <br/>
            Costo: €10 per 12 ore / €20 per 24 ore
            <br/>
            Segnaliamo, inoltre, che vi è un:
            {<ul>
                <li>Parcheggio gratuito in via Caldera 21, a 5 minuti di distanza a piedi (parcheggio CBP gratuito 24/h).</li>
                <li>Parcheggio gratuito in via Novara (prima dell’incrocio con via Caldera) 2 minuti distanza a piedi.</li>
                <li>Parcheggio custodito e coperto <a href={"https://www.onepark.co/it/"} target={"_blank"}>Onepark</a>, zona stadio, da verificare la disponibilità sul sito.</li>
            </ul>}
        </>,
    },
}